import type { NodeDefinition } from '../types';

export const outputPreviewNode: NodeDefinition = {
  type: 'output.preview',
  category: 'Output',
  label: 'Live Preview',
  description: 'Displays the final evaluated visual output in the studio preview panel',
  inputs: [
    { id: 'source', name: 'Source', type: 'any' },
  ],
  outputs: [
    { id: 'display', name: 'Display', type: 'any' },
  ],
  params: [
    { id: 'title', name: 'Stream Label', type: 'text', defaultValue: 'Final Output' },
  ],
  processor: (inputs) => {
    return {
      display: inputs.source ?? null,
    };
  },
};
